function loadScript(url) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // ie 浏览器
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        document.getElementsByTagName('head')[0].removeChild(script);
      }
    };
  } else {
    //其他
    script.onload = function () {
      document.getElementsByTagName('head')[0].removeChild(script);
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
export default function bpitLog(options) {
  if (!options) {
    console.log('bpit error: need options');
    return;
  }
  if (!options.group) {
    console.log('bpit error: need options.group');
    return;
  }
  if (!options.project) {
    console.log('bpit error: need options.project');
    return;
  }
  if (!options.hasOwnProperty('env')) {
    console.log('bpit error: need options.env');
    return;
  }
  if (!options.hasOwnProperty('version')) {
    console.log('bpit error: need options.version');
    return;
  }
  // upload data
  var uploadData = ['https://es.zhiyinlou.com/log.js?'];
  uploadData.push('group=' + options.group);
  uploadData.push('&project=' + options.project);
  uploadData.push('&env=' + options.env);
  uploadData.push('&version=' + options.version);
  uploadData.push('&method=' + options.method);
  if (options.yachid) uploadData.push('&yachid=' + options.yachid);
  if (options.workcode) uploadData.push('&workcode=' + options.workcode);
  if (options.timestamp) uploadData.push('&timestamp=' + options.timestamp);
  if (options.errorcode) uploadData.push('&errorcode=' + options.errorcode);
  if (options.message) uploadData.push('&message=' + options.message);
  // api load time
  if (options.api && options.time) {
    uploadData.push('&api=' + options.api);
    uploadData.push('&load_time=' + options.time);
  }
  var uploadDataUrl = uploadData.join('');
  loadScript(uploadDataUrl);
  if (options.env != 'online') console.log(uploadDataUrl);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/utils/bpitLog.js
// module id = null
// module chunks = 